export class TTEntidades {
  entidade: string;
  description: string;
  visible: boolean;
}
